'use client'
import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'

import styles from './AmountAdornment.module.css'

const AmountAdornment: FC<{
	className?: string
	type: string
}> = (props): ReactElement => {
	const { type, className } = props
	return (
		<div className={classNames({ [(className as any)]: !!className }, styles.root)}>
			<p className={styles.amountType}>{type}</p>
		</div>
	)
}

export default AmountAdornment
